import clsx from "clsx";

const GreenDot = ({ className, ...props }) => (
  <div
    class={clsx(
      className,
      "w-2.5 h-2.5 rounded-full bg-green-300 animate-pulse"
    )}
    {...props}
  />
);

export default GreenDot;
